import React from 'react';
import Img from 'react-image';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames/bind';

import styles from './recruitment.module.scss';
import processImg02 from '../../img/Telus_One_page-02.png';
import processImg03 from '../../img/Telus_One_page-03.png';
import processImg04 from '../../img/Telus_One_page-04.png';
import processImg05 from '../../img/Telus_One_page-05.png';
import processImg06 from '../../img/Telus_One_page-06.png';
import processImg07 from '../../img/Telus_One_page-07.png';
import processImg08 from '../../img/Telus_One_page-08.png';
import processImg09 from '../../img/Telus_One_page-09.png';

import benefitsImg19 from '../../img/Telus_One_page-19.png';
import benefitsImg18 from '../../img/Telus_One_page-18.png';
import benefitsImg17 from '../../img/Telus_One_page-17.png';
import benefitsImg16 from '../../img/Telus_One_page-16.png';
import benefitsImg15 from '../../img/Telus_One_page-15.png';
import benefitsImg14 from '../../img/Telus_One_page-14.png';
import benefitsImg13 from '../../img/Telus_One_page-13.png';
import benefitsImg12 from '../../img/Telus_One_page-12.png';
import benefitsImg11 from '../../img/Telus_One_page-11.png';
import benefitsImg10 from '../../img/Telus_One_page-10.png';

let cx = classNames.bind(styles);

const Benefits = () => {
	const { t } = useTranslation();

	return (
		<section id='benefits' className={cx({ benefits: true })}>
			<div className='container flex flex-col w-full mx-auto'>
				<h1 className='font-HelveticaNeueLTStd-Bold text-telus-purple text-2xl lg:text-3xl px-4 lg:py-4'>
					Our benefits
				</h1>
				<div className='flex flex-col lg:flex-row w-full'>
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center px-10 py-4 lg:p-10 text-center'>
						<Img src={benefitsImg19} className='w-8/12 pb-4' />
					</div>
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center px-10 py-4 lg:p-10 text-center'>
						<Img src={benefitsImg18} className='w-8/12 pb-4' />
					</div>
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center px-10 py-4 lg:p-10 text-center'>
						<Img src={benefitsImg17} className='w-8/12 pb-4' />
					</div>
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center px-10 py-4 lg:p-10 text-center'>
						<Img src={benefitsImg16} className='w-8/12 pb-4' />
					</div>
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center px-10 py-4 lg:p-10 text-center'>
						<Img src={benefitsImg15} className='w-8/12 pb-4' />
					</div>
				</div>
				<div className='flex flex-col lg:flex-row w-full'>
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center px-10 py-4 lg:p-10 text-center'>
						<Img src={benefitsImg14} className='w-8/12 pb-4' />
					</div>
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center px-10 py-4 lg:p-10 text-center'>
						<Img src={benefitsImg13} className='w-8/12 pb-4' />
					</div>
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center px-10 py-4 lg:p-10 text-center'>
						<Img src={benefitsImg12} className='w-8/12 pb-4' />
					</div>
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center px-10 py-4 lg:p-10 text-center'>
						<Img src={benefitsImg11} className='w-8/12 pb-4' />
					</div>
					<div className='flex flex-col w-full lg:w-1/5 justify-start items-center px-10 py-4 lg:p-10 text-center'>
						<Img src={benefitsImg10} className='w-8/12 pb-4' />
					</div>
				</div>
			</div>
		</section>
	);
};

export default Benefits;
